import React from "react";

const newlineRegex = /(\r\n|\r|\n)/g;

export const nl2br = str => {
	if (typeof str === "number") {
		return str;
	} else if (typeof str !== "string") {
		return "";
	}

	return str.split(newlineRegex).map(function(line, index) {
		if (line.match(newlineRegex)) {
			return React.createElement("br", { key: index });
		}
		return line;
	});
};



// WEBPACK FOOTER //
// ./src/utils/nl2br.js